import React, { useState } from 'react';
import Button from './ui/Button';

export default function RecipientSummary({ recipients = [], error = '' }) {
  const [expanded, setExpanded] = useState(false);
  const names = recipients.map((recipient) => recipient.name).join(', ');
  return (
    <div className={`sp-panel sp-panel--muted p-3 ${error ? 'sp-panel--critical' : ''}`}>
      <div className="sp-label">Who will see this</div>
      {recipients.length === 0 ? (
        <div className="text-xs sp-warning-text mt-1">No recipients selected yet.</div>
      ) : (
        <div className="text-xs sp-muted mt-1">
          This entry will be shared with {names} ({recipients.length}).
        </div>
      )}
      {recipients.length > 2 && (
        <Button size="sm" variant="ghost" onClick={() => setExpanded((prev) => !prev)}>
          {expanded ? 'Hide list' : 'View details'}
        </Button>
      )}
      {expanded && (
        <div className="text-xs sp-muted mt-2">
          {recipients.map((recipient) => `${recipient.name}${recipient.meta ? ` · ${recipient.meta}` : ''}`).join(', ')}
        </div>
      )}
      {error && <div className="text-xs sp-warning-text mt-2">{error}</div>}
    </div>
  );
}
